import type { IconData } from '@stacksjs/iconify-core'

export const lv4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#fff\" d=\"M0 0h640v480H0z\"/><path fill=\"#981e32\" d=\"M0 0h640v192H0zm0 288h640v192H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default lv4x3
